import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { PermissionChecker } from '../../session'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import { useTabsOptions } from './tabs/_data/tabsOptions'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import WebhookLoader from './_load/WebhookLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'

const WebhookModal = props => {
  const tabsOptions = useTabsOptions()

  return (
    <ControlledModal width="48rem" {...props}>
      <PermissionChecker any={['listPublicToken']}>
        <WebhookLoader>
          <TabsContext options={tabsOptions}>
            <ModalHeader />
            <HorizontalLine thin lineColor={COLORS.light2} />
            <Separator weight={6} />
            <TabsContent />
          </TabsContext>
        </WebhookLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default WebhookModal
